import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.mjs'

const pressLogos = (() => {
  const EL_SECTION = '[data-press-logos]';
  const EL_CAROUSEL = '[data-press-logos-carousel]';
  const EL_SLIDE = '[data-press-logos-slide]';
  const EL_PAGINATION = '[data-press-logos-pag]';

  const instances = {};

  function initCarousel(elSection) {
    const elCarousel = elSection.querySelector(EL_CAROUSEL);
    const elSlides = elSection.querySelectorAll(EL_SLIDE);

    const { autoplay, id } = elSection.dataset;
    const options = {
      loop: true,
      pagination: { el: EL_PAGINATION },
      // autoplay: autoplay == 'false' ? false : JSON.parse(autoplay),
      autoplay: {
        delay: 2000,
      },
      breakpoints: {
        1024: {
          slidesPerView: "auto",
          pagination: false,
          autoplay: false,
          loop: false,
          allowTouchMove: false,
        }
      }
    }
    
    instances[id] = new Swiper(elCarousel, options);
  }

  function init() {
    const elSections = document.querySelectorAll(EL_SECTION);
    elSections.forEach(el => {
      initCarousel(el);
    })
  }

  return {
    init
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  pressLogos.init();
})